<template>
  <div style="height: 100%">
    <el-container style="height: 100%; border: 1px solid #eee">
      <el-aside width="200px" style="height: 100%; background-color: rgb(238, 241, 246)">
        <Aside />
      </el-aside>

      <el-container>
        <el-header style="text-align: right; font-size: 12px;border-bottom: 1px;">
          <Header />
        </el-header>

        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<style>
.el-header {
  background-color: #B3C0D1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}
</style>

<script>

import Aside from '@/components/Aside'
import Header from '@/components/Header'

export default {
  components: {
    Aside,
    Header
  },
  data () {
    return {
    }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
    }
  }
}
</script>
